import React from 'react'

import IncidentDate from '../../incidents/components/IncidentDate'
import IncidentDetailsSection from '../../incidents/components/IncidentDetailsSection'

import { useSelectedSigEvent, useIncident } from '../hooks'

import styles from './SigEventDetails.module.css'

const detailFormat = (detail) =>
  (detail && detail.trim ? detail.trim() : detail) || '-'
const detailGroupFormat = (group) => {
  Object.keys(group).forEach((key) => (group[key] = detailFormat(group[key])))
  return group
}

const SigEventsDetails = () => {
  const sigevent = useSelectedSigEvent()
  const incident = useIncident(sigevent && sigevent.incidentId) || {}

  if (!sigevent) return null

  const {
    address,
    latitude,
    longitude,
    createdDate,
    modifiedDate,
    status,
    subject,
    description,
  } = sigevent

  /* eslint-disable */
  const basic = detailGroupFormat({
    ['Event Type']: (incident.type && incident.type.name) || 'Unknown',
    ['Event']: incident.name || 'Unknown',
    ['Subject']: subject,
    ['Status']: status,
  })

  const location = detailGroupFormat({
    ['Address']: address,
    ['Location']: `${longitude}, ${latitude}`,
  })

  const editors = detailGroupFormat({
    ['Created']: <IncidentDate date={createdDate} />,
    ['Modified']: <IncidentDate date={modifiedDate} />,
  })
  /* eslint-enable */

  return (
    <div className={styles.details}>
      <IncidentDetailsSection title="Basic" details={basic} />
      <IncidentDetailsSection title="Location" details={location} />
      <IncidentDetailsSection title="Editors" details={editors} />
      <div className={styles.sectionTitle}>Description</div>
      <span className={styles.comments}>{description}</span>
    </div>
  )
}

export default SigEventsDetails
